import {
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import { LifecycleStep } from "./buildLifecycleSteps";

type LifecycleStepsTableProps = {
  steps: LifecycleStep[];
  emptyMessage?: string;
};

const LifecycleStepsTable = ({
  steps,
  emptyMessage = "No timed lifecycle steps recorded yet.",
}: LifecycleStepsTableProps) => {
  return (
    <Box
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="md"
      bg="white"
      overflowX="auto"
    >
      <Table size="sm" variant="simple">
        <Thead bg="gray.50">
          <Tr>
            <Th>Stage</Th>
            <Th>Time</Th>
            <Th>Person</Th>
            <Th maxW="120px" whiteSpace="normal" lineHeight="1.3">
              Diff from previous stage
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {steps.length === 0 ? (
            <Tr>
              <Td colSpan={4}>
                <Text color="gray.500" fontSize="sm">
                  {emptyMessage}
                </Text>
              </Td>
            </Tr>
          ) : (
            steps.map((step) => (
              <Tr key={step.id}>
                <Td fontWeight="medium">
                  {step.statusTooltip ? (
                    <Tooltip
                      label={step.statusTooltip}
                      hasArrow
                      placement="top-start"
                      openDelay={200}
                    >
                      <Box as="span" cursor="help">
                        {step.status}
                      </Box>
                    </Tooltip>
                  ) : (
                    step.status
                  )}
                </Td>
                <Td whiteSpace="nowrap">{step.at}</Td>
                <Td>{step.person}</Td>
                <Td whiteSpace="nowrap">{step.diffFromPrevious}</Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </Box>
  );
};

export default LifecycleStepsTable;
